import {ref, reactive, computed, watch, toRefs} from "@vue/composition-api";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import Loader from "@/utility/loader";
import AccountModule from "@/store/modules/account";
import NoteModule from "@/store/modules/note";
import {Router} from "@/composables/Router";
import {$t} from "@/i18n";

export default function UseNoteEdit(relatedType, relatedId, editNote, onSave, files_input, richTextEditor) {
    const loader = reactive(new Loader());
        const { current_account } = AccountModule();
        const { saveNote } = NoteModule();
        const router = Router();
        const relatedIdWatch = computed(() => relatedId);

        let current_note = reactive({
            id: 0,
            account_id: current_account.value.id,
            related_type: relatedType,
            related_id: relatedId,
            comments: "",
            type: "info",
            files: [],
            is_pinned: false,
            uploaded_files: [],
            deleted_files: []
        });
        const edit_note = computed(() => {
            return editNote;
        });
        watch(edit_note, val => {
            if (val && val.id) {
                current_note = reactive(Object.assign(current_note, val));
            }
        });
        const note_topics = ref([
            { text: $t("Notes"), value: "info" },
            { text: $t("Document"), value: "document" },
            { text: $t("Email"), value: "email" },
            { text: $t("Billing"), value: "billing" },
        ]);
        const resetCurrentNote = () => {
            current_note.id = 0;
            current_note.account_id = current_account.value.id;
            current_note.related_type = relatedType;
            current_note.related_id = relatedId;
            current_note.comments = "";
            current_note.type = "info";
            current_note.files = [];
            current_note.uploaded_files = [];
            current_note.deleted_files = [];
            current_note.is_pinned = false;
            files_input.value = "";
        };

        const canSaveNote = () => {
            if (current_note.uploaded_files.length) {
                return true
            }

            if (current_note.files.length) {
                return true
            }

            if (current_note.deleted_files.length) {
                return true
            }

            if (current_note.comments.length) {
                return true
            }

            return false;
        }

        const saveNoteClick = async () => {
            if (!canSaveNote())
                return;

            loader.withLoader(async () => {
                try {
                    const resp = await saveNote(current_note)
                    resetCurrentNote();

                    onSave(resp)
                    //context.emit("change", resp);
                    //context.emit("close");
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        };
        const toggleIsPinned = () => {
            current_note.is_pinned = !current_note.is_pinned
        }
        const isPinned = computed(() => {
            return Boolean(current_note.is_pinned)
        })
        const addFiles = () => {
            files_input.value.click();
        };
        const removeFile = key => {
            const deleted_file_arr = current_note.files.splice(key, 1);
            const deleted_file = deleted_file_arr[0];
            if (deleted_file) {
                current_note.deleted_files.push(deleted_file);
            }
        };
        const removeUploadedFile = key => {
            current_note.uploaded_files.splice(key, 1);
        };
        const handleFilesUpload = () => {
            const uploadedFiles = files_input.value.files;
            for (let i = 0; i < uploadedFiles.length; i++) {
                current_note.uploaded_files.push(uploadedFiles[i]);
            }
        };

        const activeTab = computed({
            get: () => note_topics.value.findIndex((x) => x.value === current_note.type),
            set: (index) => current_note.type = note_topics.value[index].value
        })

        const addLink = () => {
            let quill = richTextEditor.value.$refs.richTextEditorContent.quill;

            let selection = quill.getSelection()

            let func = quill.theme.options.theme.DEFAULTS.modules.toolbar.handlers.link
            func = func.bind(richTextEditor.value.$refs.richTextEditorContent)
            func(selection)
        }

        watch(relatedIdWatch, () => {
            current_note.related_id = relatedId
        })

        return {
            ...toRefs(current_note),
            files_input,
            note_topics,
            saveNoteClick,
            addFiles,
            removeFile,
            removeUploadedFile,
            handleFilesUpload,
            toggleIsPinned,
            isPinned,
            activeTab,
            addLink,
            richTextEditor,
            loader,
            editNote: edit_note
        };
}
